import analyticsMiddleware from './analytics';
import asyncMiddleware from './async';
import dbMiddleware from './db';

export default [asyncMiddleware, dbMiddleware, analyticsMiddleware];
